import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'upload-audio-note',
  templateUrl: './upload-audio-note.component.html',
  styleUrls: ['./upload-audio-note.component.scss']
})
export class UploadAudioNoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
